module.exports = __webpack_public_path__ + "static/media/heroGraphic2000.d896c883.png";